// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__SMdHW","footer":"ModalError_footer__24dcL"};